//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { shallowEqual, useSelector } from 'react-redux'
import { useAllBook, useBookOrder, useUserAllowedBooks } from 'store/books/selectors';
import { getClassAllowedBooks } from 'utils/lib/ebookHelper';
import { useCurrentOrgPermission } from 'store/organizations/selectors';
import { useCurrentUser } from 'store/users/selectors';
import { useMemo } from 'react';


//  ----------------------------------------------------------------------------
//  Selectors
//  ----------------------------------------------------------------------------

//  -- Examples data ------------------
const selectore = (state) => state.currentClass;
const teacherSelector = (state) => state.currentAllTeacherClass;
//  -- Examples array selector --------

export const useCurrentClassBook = () => {
    const orgPermissions = useCurrentOrgPermission()
    const userAllowedBooks = useUserAllowedBooks()
    const currentClass = useCurrentClass()
    const bookOrder = useBookOrder()
    const currentUser = useCurrentUser()
    const booksAllList = useAllBook()
    const allowed_books = useMemo(() => getClassAllowedBooks(orgPermissions, currentClass, userAllowedBooks, bookOrder, currentUser, booksAllList), [currentClass, orgPermissions, booksAllList, currentUser, userAllowedBooks, bookOrder]);
    return allowed_books;
}

export const useCurrentClass = () =>{
    const selectedData = useSelector(selectore, shallowEqual)
    return selectedData;
}

export const useCurrentClassTeacher = () =>{
    const selectedData = useSelector(teacherSelector, shallowEqual)
    return selectedData;
}